AFRAME.registerComponent('sector-selector', {
    schema: {
        target: { type: 'selector', default: null }
    },

    init: function () {
        this.sectorNames = {
            1: "Utilities",
            2: "Energy",
            3: "Materials",
            4: "Finance",
            5: "Health",
            6: "RE",
            7: "Tech",
            8: "Industrials",
            9: "Comm",
            10: "Consumer Staples",
            11: "Consumer Discretionary"
        };
        this.selectedSectors = new Set([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
        this.topN = 6;
        this.maxN = 10;
        this.renderUI();
        this.updateTarget();
    },

    renderUI: function () {
        const container = this.el;
        container.innerHTML = "";

        container.setAttribute('position', '.45 -0.36 0.01');
        container.setAttribute('scale', '.23 .23 .23');

        // Add "Top:" text label
        const topLabel = document.createElement('a-text');
        topLabel.setAttribute('value', 'Top:');
        topLabel.setAttribute('position', '-0.5 1.2 0');
        topLabel.setAttribute('align', 'left');
        topLabel.setAttribute('scale', '0.5 0.5 0.5');
        topLabel.setAttribute('color', 'white');
        topLabel.setAttribute('shader', 'msdf');
        topLabel.setAttribute('font', 'roboto');
        topLabel.setAttribute('negate', 'true');
        topLabel.setAttribute('alphaTest', '0.7');
        container.appendChild(topLabel);

        // Top N input field
        const topNInput = document.createElement('a-entity');
        topNInput.setAttribute('ui-input', {
            placeholder: 'Top N',
            value: this.topN.toString(),
            width: 0.4,
            height: 0.2,
            color: '#555',
            focuscolor: '#E0E0E0'
        });
        topNInput.setAttribute('position', '0 1.2 0');
        topNInput.setAttribute('class', 'interactable');
        topNInput.setAttribute('data-raycastable', '');
        topNInput.addEventListener('change', (event) => {
            const newTopN = parseInt(event.detail.value, 10);
            if (!isNaN(newTopN)) {
                this.topN = Math.min(Math.max(newTopN, 1), this.maxN); // Cap between 1 and 10
                topNInput.setAttribute('ui-input', 'value', this.topN.toString());
                this.updateTarget();
            }
        });
        container.appendChild(topNInput);

        // Up arrow button
        const upArrow = document.createElement('a-triangle');
        upArrow.setAttribute('vertex-a', '0 0.1 0');
        upArrow.setAttribute('vertex-b', '-0.05 -0.05 0');
        upArrow.setAttribute('vertex-c', '0.05 -0.05 0');
        upArrow.setAttribute('position', '0.35 1.3 0.01');
        upArrow.setAttribute('material', 'color: white; shader: standard'); // Non-transparent, illuminated
        upArrow.setAttribute('class', 'interactable');
        upArrow.setAttribute('data-raycastable', '');
        upArrow.addEventListener('click', () => {
            console.log('up topN: ', this.topN.toString());
            if (this.topN < this.maxN) {
                this.topN++;
                topNInput.setAttribute('ui-input', 'value', this.topN.toString());
                this.updateTarget();
            }
            upArrow.setAttribute('material', 'color: grey');
            setTimeout(() => upArrow.setAttribute('material', 'color: white'), 200);
        });
        upArrow.addEventListener('mouseenter', () => upArrow.setAttribute('material', 'color: cyan'));
        upArrow.addEventListener('mouseleave', () => upArrow.setAttribute('material', 'color: white'));
        container.appendChild(upArrow);

        // Down arrow button
        const downArrow = document.createElement('a-triangle');
        downArrow.setAttribute('vertex-a', '0 0.1 0');
        downArrow.setAttribute('vertex-b', '-0.05 -0.05 0');
        downArrow.setAttribute('vertex-c', '0.05 -0.05 0');
        downArrow.setAttribute('position', '0.35 1.1 0.01');
        downArrow.setAttribute('rotation', '0 0 180');
        downArrow.setAttribute('material', 'color: white; shader: standard'); // Non-transparent, illuminated
        downArrow.setAttribute('class', 'interactable');
        downArrow.setAttribute('data-raycastable', '');
        downArrow.addEventListener('click', () => {
            console.log('down topN: ', this.topN.toString());
            if (this.topN > 1) {
                this.topN--;
                topNInput.setAttribute('ui-input', 'value', this.topN.toString());
                this.updateTarget();
            }
            downArrow.setAttribute('material', 'color: grey');
            setTimeout(() => downArrow.setAttribute('material', 'color: white'), 200);
        });
        downArrow.addEventListener('mouseenter', () => downArrow.setAttribute('material', 'color: cyan'));
        downArrow.addEventListener('mouseleave', () => downArrow.setAttribute('material', 'color: white'));
        container.appendChild(downArrow);

        // Sector list with checkboxes (now flat)
        Object.entries(this.sectorNames).forEach(([id, name], index) => {
            const sectorId = parseInt(id);

            const checkbox = document.createElement('a-box');
            checkbox.setAttribute('position', `-0.8 ${1 - index * 0.2} 0`);
            checkbox.setAttribute('width', '0.1');
            checkbox.setAttribute('height', '0.1');
            checkbox.setAttribute('depth', '0.01');
            checkbox.setAttribute('material', `color: ${this.selectedSectors.has(sectorId) ? 'green' : 'red'}; shader: flat`); // Flat shader
            checkbox.setAttribute('class', 'interactable');
            checkbox.setAttribute('data-raycastable', '');
            checkbox.addEventListener('click', () => {
                if (this.selectedSectors.has(sectorId)) {
                    this.selectedSectors.delete(sectorId);
                    checkbox.setAttribute('material', 'color: red; shader: flat');
                } else {
                    this.selectedSectors.add(sectorId);
                    checkbox.setAttribute('material', 'color: green; shader: flat');
                }
                this.updateTarget();
            });
            container.appendChild(checkbox);

            const label = document.createElement('a-troika-text');
            label.setAttribute('value', name);
            label.setAttribute("font-size", "0.15");
            label.setAttribute("align", "left");
            label.setAttribute("anchor", "left");
            label.setAttribute("baseline", "center");
            label.setAttribute("depth-offset", "1");
            label.setAttribute('position', `-0.6 ${1 - index * 0.2} 0`);
            label.setAttribute('color', 'white');
            container.appendChild(label);
        });
    },

    updateTarget: function () {
        if (!this.data.target || !this.data.target.components['stock-cube-visualizer']) return;

        const targetComponent = this.data.target.components['stock-cube-visualizer'];
        const dataSource = targetComponent.data.dataSource;
        if (['top-gainers-sec', 'top-losers-sec', 'top-vol-sec', 'top-dollar-vol-sec',
            'top-dollar-vol-sec'].includes(dataSource)) {
            const sectorIds = Array.from(this.selectedSectors).sort((a, b) => a - b);
            this.data.target.setAttribute('stock-cube-visualizer', {
                sectorIds: sectorIds,
                topN: this.topN
            });
        }
    }
});